import { t } from "@/i18n-js/instance";
import { EVENT_LAYOUT_ADMIN_OPTIONS } from "@/react/components/AllEvents/constants";
import { useUpdateCommunitySetting } from "@/react/hooks/UseCommunitySetting";
import { usePunditUserContext } from "@circle-react/contexts";
import { Button } from "@circle-react-uikit/Button";
import { Drawer } from "@circle-react-uikit/Drawer";
import { Form } from "@circle-react-uikit/Form";
import { useToast } from "@circle-react-uikit/ToastV2";

const localeScope = "all_events.settings";

interface SettingsInterface {
  onClose: () => void;
  open: boolean;
}

export const Settings = ({ open, onClose }: SettingsInterface) => {
  const toastr = useToast();
  const { isLoading, currentCommunitySettings } = usePunditUserContext();

  const updateCommunitySettingMutation = useUpdateCommunitySetting({
    onSuccess: () => {
      toastr.success(t(`${localeScope}.save.success`));
      onClose();
    },
    onError: () => {
      toastr.error(t(`${localeScope}.save.error`));
    },
  });
  if (!currentCommunitySettings || isLoading) {
    return null;
  }

  const {
    public_events_view,
    allow_member_public_events_view: hasMemberPublicEventsView,
  } = currentCommunitySettings;

  const onSubmit = (formData: any) => {
    updateCommunitySettingMutation.mutate({
      data: { community_settings: currentCommunitySettings },
      updates: formData,
    });
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={t(`${localeScope}.title`)}
      noWrapperPadding
    >
      <Form
        onSubmit={onSubmit}
        defaultValues={{
          public_events_view,
          allow_member_public_events_view: hasMemberPublicEventsView,
        }}
        className="h-full"
        formClassName="flex flex-col h-full"
      >
        <div className="grow px-6">
          <Form.Item
            name="public_events_view"
            label={t([localeScope, "form.view"])}
            hideDescription
            hideBorder
          >
            <Form.SelectNative
              options={EVENT_LAYOUT_ADMIN_OPTIONS}
              defaultValue={public_events_view}
              name="public_events_view"
            />
          </Form.Item>
          <Form.Item
            name="allow_member_public_events_view"
            label={t([localeScope, "form.allow_members_to_switch_view"])}
            hideDescription
            hideBorder
            fullWidth
            inline
          >
            <Form.ToggleSwitch
              variant="small"
              name="allow_member_public_events_view"
            />
          </Form.Item>
        </div>
        <Drawer.Footer>
          <Button
            disabled={updateCommunitySettingMutation.isLoading}
            type="submit"
            variant="primary"
            full
          >
            {t(`${localeScope}.save.button`)}
          </Button>
        </Drawer.Footer>
      </Form>
    </Drawer>
  );
};
